var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandHtml5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "HTML5",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e34f26",
    d: "M71 460L30 0h451l-41 460-185 52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ef652a",
    d: "M256 472l149-41 35-394H256"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M256 208h-75l-5-58h80V94H114l15 171h127zm-1 147l-63-17-4-45h-56l7 89 116 32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M255 208v57h70l-7 73-63 17v59l116-32 16-174zm0-114v56h137l5-56z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandHtml5);
export default __webpack_public_path__ + "static/media/brand-html5.6e7b1b463015c056aeb9a624c8dc2876.svg";
export { ForwardRef as ReactComponent };